import {Suspense, useContext} from 'react';
import {CircularProgress, makeStyles, Typography, useTheme, Divider} from '@material-ui/core';
import Header from './Header';
import LocaleSwitcher from "@super-template/core/src/LocaleSwitcher";
import {SettingsContext} from 'components/Routes/application/utils';
import CookieAlert from "./Header/CookieAlert";
import useSessionStorage from "@postinumero/storage/useSessionStorage";
import {generatePath, Link, useParams} from "react-router-dom";
import {path as accessPath} from "../Routes/accessibilityStatement";
import {FormattedMessage} from "react-intl";
import messages from "@super-template/messages";

const useStyles = makeStyles((theme) => ({
  title: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  },
  logo: {
    position: 'relative',
    background: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 70,
    width: 170,
    marginRight: 40
  },
  square: {
    width: 50,
    height: 50,
    background: 'white',
    position: 'absolute',
    transform: 'rotate(45deg)',
    top: 10,
    left: 144
  },
  switcher: {
    paddingRight: 20
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      '& a': {
        marginBottom: theme.spacing(2)
      }
    },
  }
}));

const hasAccessibilityStatement = {
  HYVINVOINT: true, MTLH: true, NASYLOMAT: true, SOLARISLOM: true, SEMESTER: true, PHT: true, PHTPERHE: true
};

export default function Page({title, children}) {
  const classes = useStyles();
  const theme = useTheme();
  const {organization} = useParams();
  const {language} = useContext(SettingsContext);
  const [cookie_accepted] = useSessionStorage('cookie_accepted');
  if (!title) title = "LOTU";

  return (
    <Header className={classes.root} title={title}>
      <Header.AppBar title={title}>
        <div>
          <div className={classes.square}/>
          <div className={classes.logo}>
            <img src={theme.logo} alt=""/>
          </div>
        </div>
        <div className={classes.title}>
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
        </div>
        <div className={classes.switcher}>
          <LocaleSwitcher languages={language?.languages}/>
        </div>
      </Header.AppBar>
      <Header.Content title={title}>
        <Suspense fallback={<CircularProgress/>}>{children}</Suspense>
        {!cookie_accepted && <CookieAlert/>}
      </Header.Content>
      <Header.Footer>
        <Divider />
        <div className={classes.footer}>
          © Lomajärjestöjen yhteistyöryhmä LYR
          {hasAccessibilityStatement[organization] &&
          <Link to={generatePath(accessPath, {organization})}>
            <FormattedMessage {...messages.accessibility_statement} />
          </Link>}
        </div>
      </Header.Footer>
    </Header>
  );
}
